{
  "REGISTER": {
    "TRY_WOOT": "Sukurti paskyrą",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Registras",
    "TESTIMONIAL_HEADER": "Tereikia vieno žingsnio, kad judėtume į priekį",
    "TESTIMONIAL_CONTENT": "Liko vienas žingsnis, kad įtrauktumėte savo klientus, išlaikytumėte juos ir rastumėte naujų.",
    "TERMS_ACCEPT": "Kurdami paskyrą sutinkate su mūsų <a href=\"https://www.chatwoot.com/terms\">T & C</a> ir <a href=\"https://www.chatwoot.com/ privacy-policy\">Privatumo politika</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Užsiregistruoti su Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Įmonės pavadinimas",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Pilnas vardas",
      "PLACEHOLDER": "Enter your full name. eg: Bruce Wayne",
      "ERROR": "Full name is too short"
    },
    "EMAIL": {
      "LABEL": "Darbinis el. paštas",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Slaptažodis",
      "PLACEHOLDER": "Slaptažodis",
      "ERROR": "Password is too short",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm Password",
      "PLACEHOLDER": "Confirm Password",
      "ERROR": "Slaptažodžiai nesutampa."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Could not connect to Woot Server, Please try again later"
    },
    "SUBMIT": "Sukurti paskyrą",
    "HAVE_AN_ACCOUNT": "Jau turi prisijungimo paskyrą?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Resend verification email",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
